var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"inset-0 wave-background--vertical",class:{ 'wave-background--is-animating': _vm.isAnimating },style:(_vm.style)})
}
var staticRenderFns = []

export { render, staticRenderFns }